import { useCallback } from 'react';
import { useGetUserFullNameWithFallback } from '../use-get-user-full-name-with-fallback';

type P = {
  firstName?: null | string;
  lastName?: null | string;
};

export const useGetUserNameWithFallback = () => {
  const getFullNameWithFallback = useGetUserFullNameWithFallback();

  return useCallback(
    ({ firstName, lastName }: P = {}) => getFullNameWithFallback({ firstName, lastName }),
    [getFullNameWithFallback],
  );
};
